"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function maskNumber(number, mask = '•') {
    const last4Digits = number.slice(-4);
    return last4Digits.padStart(number.length, mask);
}
exports.default = maskNumber;
